export default __webpack_public_path__ + "static/media/tshirt_shop.42c172ac.png";